// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import ModalClose from "@adl/XDL/Icons/ModalClose";
import { ComponentThemeProps } from "@insite/mobius/globals/baseTheme";
import { css, keyframes } from "styled-components";

const ModalPresentationPropsDefault: ComponentThemeProps["modal"]["defaultProps"] = {
    cssOverrides: {
        headlineTypography: css`
            margin-bottom: 0;
            display: inline-block;
        `,
        titleButton: css`
            padding: 0;
        `,
    },
    closeButtonProps: {
        shape: "pill",
        buttonType: "solid",
        color: "common.background",
        size: 36,
    },
    // XNG-Change: close button
    closeButtonIconProps: {
        src: ModalClose,
        size: 10,
    },
    transition: {
        enabled: true,
        length: 300,
        overlayEntryKeyframes: keyframes`
            from { margin-top: -100px; }
            to { margin-top: 0; }
        `,
        overlayExitKeyframes: keyframes`
            from { margin-top: 0; }
            to { margin-top: -100px; }
        `,
        scrimEntryKeyframes: keyframes`
            from { opacity: 0; }
            to { opacity: 1; }
        `,
        scrimExitKeyframes: keyframes`
            from { opacity: 1; }
            to { opacity: 0; }
        `,
    },
};

export default ModalPresentationPropsDefault;
